{
  "possibleTypes": {
    "AttendanceInterface": [
      "ChildAttendance",
      "InstructorAttendance"
    ],
    "FieldInterface": [
      "CheckboxField",
      "DateField",
      "NumberField",
      "TextField",
      "TimeField",
      "TimerField",
      "TimestampField"
    ]
  }
}